import {
  HeroSection,
  FeaturesSection,
  UseCasesSection,
  CtaSection,
} from "@/components/product/knowledge-base"
import { FooterSection } from "@/components/home/footer"
import { usePageTitle } from "@/hooks/use-page-title"

/**
 * Knowledge Base product page.
 * Showcases the AI-powered knowledge management platform and its capabilities.
 */
export function KnowledgeBaseProductPage() {
  const pageTitle = usePageTitle(
    "Knowledge Base",
    "Build rich knowledge bases from documents, websites, and text. Power your AI agents with contextual intelligence for smarter responses."
  )

  return (
    <div className="w-full">
      {pageTitle}
      <HeroSection />
      <FeaturesSection />
      <UseCasesSection />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

KnowledgeBaseProductPage.displayName = "KnowledgeBaseProductPage"
